<template lang="html">
  <div class="users-admin-wrapper">
    <div class="title">
      <span>Korisnički nalozi</span>
      <input @keyup="getUsers" v-model="search" type="text" placeholder="search" name="" value="">
    </div>
    <div class="switcher">
      <div @click="usrType = 0" class="btn" :class="{ inv : usrType === 1 }">
        Korisnici
      </div>
      <div @click="usrType = 1" class="btn" :class="{ inv : usrType === 0 }">
        Administratori
      </div>
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td>Ime</td>
            <td>Kao prodavac</td>
            <td>Kao kupac</td>
            <!-- <td>Banovan</td>
            <td>Otključan</td> -->
            <td></td>
            <td></td>
            <td>Ban</td>
            <td>Lock</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in users" :key="index">
            <td>
              {{user.usr_name}}
            </td>
            <td>
              {{user.seller}}
            </td>
            <td>
              {{user.buyer}}
            </td>
            <!-- <td>
              {{user.usr_banned === 0 ? 'Ne' : 'Da'}}
            </td>
            <td>
              {{user.usr_unlocked === '0' ? 'Ne' : 'Da'}}
            </td> -->
            <td>
              <div @click="openChangeUserPassModal(user)" class="btn">
                pass
              </div>
            </td>
            <td>
              <div @click="openConfirmModal(user, 'admin')" class="btn">
                {{ changeUserAdminLabel }}
              </div>
            </td>
            <td>
              <div @click="openConfirmModal(user, 'status')" class="btn">
                {{ changeUserBanLabel(user) }}
              </div>
            </td>
            <td>
              <div @click="openConfirmModal(user, 'block')" class="btn">
                {{ changeUserBlockLabel(user) }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="users.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>
<!-- todo: pagination, handle usrType change (users/admins), actions api -->
<script>
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'usersAdmin',
  data () {
    return {
      users: [],
      usrType: 0,
      page: 1,
      pageCount: 0,
      search: null
    }
  },
  mounted () {
    this.getUsers()
  },
  methods: {
    getUsers () {
      // fetch users data
      let params = {
        page: this.page,
        usrType: this.usrType
      }
      if (this.search && this.search !== '') {
        params.search = this.search
      }
      api.getAllUsers(params).then(res => {
        this.users = res.data.data
        this.pageCount = res.data.page_count
      }).catch(e => {
        console.log(e)
      })
    },
    openChangeUserPassModal (usr) {
      let modalData = {
        title: 'Resetovati password za korisnika ' + usr.usr_name,
        ok: () => {
          this.changeUserPass(usr)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    changeUserPass (usr) {
      let params = {
        password: true,
        usr_id: usr.usr_id
      }
      api.changeUser(params).then(res => {
        this.getUsers()
        this.$toast.success('Uspešno', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Greška', {
          duration: 8000
        })
      })
    },
    openConfirmModal (usr, type) {
      let modalData = {}
      if (type === 'admin') {
        modalData.title = 'Promeni admin status za korisnika ' + usr.usr_name
        modalData.ok = () => {
          this.changeUserAdmin(usr)
        }
      } else if (type === 'status') {
        modalData.title = 'Promeni ban status za korisnika ' + usr.usr_name
        modalData.ok = () => {
          this.changeUserStatus(usr)
        }
      } else if (type === 'block') {
        modalData.title = 'Promeni blokadu korisničkog naloga za korisnika ' + usr.usr_name
        modalData.ok = () => {
          this.changeUserBlock(usr)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    changeUserAdmin (usr) {
      let params = {
        admin: this.usrType === 0,
        usr_id: usr.usr_id
      }
      api.changeUser(params).then(res => {
        this.getUsers()
        this.$toast.success('Uspešno', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Greška', {
          duration: 8000
        })
      })
    },
    changeUserStatus (usr) {
      let params = {
        ban: parseInt(usr.usr_banned) === 0,
        usr_id: usr.usr_id
      }
      api.changeUser(params).then(res => {
        this.getUsers()
        this.$toast.success('Uspešno', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Greška', {
          duration: 8000
        })
      })
    },
    changeUserBlock (usr) {
      let params = {
        unlock: parseInt(usr.usr_unlocked) === 0,
        usr_id: usr.usr_id
      }
      api.changeUser(params).then(res => {
        this.getUsers()
        this.$toast.success('Uspešno', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Greška', {
          duration: 8000
        })
      })
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
      this.users = []
      this.getUsers()
    }
  },
  computed: {
    changeUserAdminLabel () {
      return this.usrType === 0 ? 'To admin' : ' To user'
    },
    changeUserBanLabel () {
      return user => {
        return parseInt(user.usr_banned) === 0 ? 'Ban' : 'Unban'
      }
    },
    changeUserBlockLabel () {
      return user => {
        return parseInt(user.usr_unlocked) === 0 ? 'Unlock' : 'Lock'
      }
    }
  },
  watch: {
    usrType: {
      handler: function () {
        this.page = 1
        this.getUsers()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.users-admin-wrapper {
  @import '@/assets/scss/tableStyles.scss';
  @import '@/assets/scss/btnStyles.scss';
  padding-left: 40px;
  box-sizing: border-box;
  height: 100%;
  position: relative;

  .table-wrapper {
    height: calc(100% - 160px);
    overflow: auto;
  }

  .title {
    margin-bottom: 40px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding-right: 20px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      max-width: 230px;
    }
    input:focus {
      outline: none;
    }
  }
  .switcher {
    display: flex;
    flex-direction: row;
    .btn {
      width: 150px;
    }
  }
}
</style>
